export function isProgressPage(currentUrl: string): boolean {
  const baseUrl = currentUrl.split('?')[0];
  return (
    baseUrl.endsWith('/companyinformation') ||
    baseUrl.endsWith('/groupreporting') ||
    baseUrl.endsWith('/annualstatement') ||
    baseUrl.endsWith('/premiumreport') ||
    baseUrl.endsWith('/validationsummary') ||
    baseUrl.endsWith('/userdefineddata') ||
    baseUrl.endsWith('/comments') ||
    baseUrl.endsWith('/PRFSubmission') ||
    baseUrl.endsWith('/PRFSubmissionComplete')
  );
}
